"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollCorrection = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var emptyPosition = {
    x: 0,
    y: 0,
};
function useScrollCorrection(getDimensions, isActive) {
    if (isActive === void 0) { isActive = true; }
    var _a = tslib_1.__read(react_1.useState(emptyPosition), 2), currentPosition = _a[0], setCurrentPosition = _a[1];
    var initialPosition = react_1.useMemo(function () {
        if (isActive) {
            return getDimensions();
        }
        else {
            return emptyPosition;
        }
    }, [isActive, getDimensions]);
    react_1.useEffect(function () {
        var updatePosition = function () {
            setCurrentPosition(getDimensions);
        };
        if (isActive) {
            document.addEventListener("scroll", updatePosition, true);
            updatePosition();
        }
        return function () { return document.removeEventListener("scroll", updatePosition, true); };
    }, [isActive, getDimensions]);
    var scrollCorrection = react_1.useMemo(function () {
        return {
            x: currentPosition.x - initialPosition.x,
            y: currentPosition.y - initialPosition.y,
        };
    }, [currentPosition, initialPosition]);
    return {
        initialPosition: initialPosition,
        currentPosition: currentPosition,
        scrollCorrection: scrollCorrection,
    };
}
exports.useScrollCorrection = useScrollCorrection;
//# sourceMappingURL=useScrollCorrection.js.map